module.exports = __webpack_public_path__ + "img/_tuurro.t6.rw.92ae0fe3.png";